import useIsPurchased from 'hooks/useIsPurchased'
import Button from 'ui/Button'
import { Flixx } from 'ui'
import { getThumbnail } from 'utils/thumbnails'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Cover, Header, Title } from './styles'


const NextEpisode = ({ episode, onPlay }) => {

  const { t } = useTranslation()
  const { isPurchased } = useIsPurchased({ contentType: 'series' })



  return (
    <Container>

      <Cover>
        <img src={getThumbnail(episode)} alt='' />
      </Cover>
      <div>
        <div>
          <Header>{t('continueWatching')}</Header>
          <Title>{t('episode')} {episode.order + 1} | {episode.title}</Title>
        </div>

        <Button isFull onClick={onPlay}>
          {t('watchNow')}
        </Button>
      </div>
    </Container>
  )
}

export default NextEpisode